// Helpers de presentación para productos (planes / addons) del catálogo GET /products.

// Etiqueta visible de un producto: el displayName tal cual (cae al slug si no hubiera).
export const productLabel = (p) => {
  if (!p) return '';
  return p.displayName || p.slug || '';
};

// Orden alfabético por etiqueta visible.
export const byProductLabel = (a, b) => productLabel(a).localeCompare(productLabel(b), 'es');
